// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1uyto","title":"BackImages_title__3x3PL","images":"BackImages_images__38UY8"};